import styled from 'styled-components';

import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import { NoSSR } from '@xing-com/crate-utils-no-ssr';
import { spaceXXL } from '@xing-com/tokens';

import { useDisplayAds } from '../../use-display-ads';
import { useAdRefresh } from '../use-ad-refresh';

import { DisplayAdLoginLeaderboard } from './leaderboard-ad';

const AdWrapper = styled.div`
  width: 728px;
  height: 90px;
  position: relative;
  z-index: 1;
  margin: ${spaceXXL};
`;

export const DisplayAdLoginLeaderboardSlot: React.FC = () => {
  const isBigScreen = useMatchMedia(
    '(min-width: 1584px) and (min-height: 900px)'
  );
  const { displayAdsAllowed } = useDisplayAds();

  const { refreshDesktop } = useAdRefresh({
    isSmallScreen: !isBigScreen,
    slots: {
      mobile: '',
      desktop: 'leaderboard',
    },
  });

  if (!displayAdsAllowed || !isBigScreen) {
    return null;
  }

  return (
    <AdWrapper>
      <NoSSR>
        <DisplayAdLoginLeaderboard refresh={refreshDesktop} />
      </NoSSR>
    </AdWrapper>
  );
};
